import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var returnSaleItemIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.14 8.941c-.57-4.293-4.199-7.671-8.519-7.921C8.601.719 4.5 4.422 3.95 9.09l-.418-.399a1.002 1.002 0 0 0-1.41.02l-.351.36 2.3 2.218c.29.281.75.281 1.04 0l2.3-2.219-.351-.36a.983.983 0 0 0-1.41-.019l-.16.149a7.693 7.693 0 0 1 8.23-6.32c2.902.242 5.472 2.19 6.5 4.921 1.59 4.23-.778 8.649-4.668 9.989-.473.16-.73.66-.63 1.148l.118.55c4.652-1.026 7.73-5.378 7.09-10.187"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.238 12.059a2.453 2.453 0 0 0-2.449-2.45H9.922c-.652 0-1.274.262-1.73.72L2.487 16.03c-.847.848-.847 2.239 0 3.11l3.25 3.25c.453.41 1 .62 1.551.62.55 0 1.11-.21 1.531-.64l5.7-5.7c.46-.46.718-1.081.718-1.73zm-1.5 2.87c0 .262-.09.493-.277.673L7.76 21.3c-.32.32-.75.21-.991 0l-3.22-3.223a.705.705 0 0 1 0-.988l5.7-5.7a.953.953 0 0 1 .672-.28h2.867c.52 0 .95.43.95.949zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.52 12.59c-.41 0-.75.34-.75.75s.34.75.75.75.75-.34.75-.75-.34-.75-.75-.75"
}));

export { returnSaleItemIcon as default };
//# sourceMappingURL=returnSaleItemIcon.js.map
